import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
  preConfig: "idle",
  session: "idle",
  quest: "idle",
  player: "idle",
  event: "idle",
};

const tutosSlice = createSlice({
  name: "tutos",
  initialState,
  reducers: {
    openTutoAlert: (state, action) => {
      state[action.payload] = "opened";
    },
    closeTutoAlert: (state, action) => {
      state[action.payload] = "closed";
    },
  },
  extraReducers: (builder) => {
    builder.addCase("auth/logout", () => initialState);
  },
});

export const tutosActions = tutosSlice.actions;

const _selectTutosAlerts = (state) => state.tutos;

export const selectTutosAlerts = createSelector(
  [(state) => _selectTutosAlerts(state)],
  (tutos) => {
    return {
      preConfig: tutos.preConfig,
      session: tutos.session,
      quest: tutos.quest,
      player: tutos.player,
      event: tutos.event,
    };
  }
);

export default tutosSlice.reducer;
